export default "__VITE_ASSET__70e43b70__"